import { render, staticRenderFns } from "./VProductWhiteList.vue?vue&type=template&id=c8178872&scoped=true"
import script from "./VProductWhiteList.vue?vue&type=script&lang=ts"
export * from "./VProductWhiteList.vue?vue&type=script&lang=ts"
import style0 from "./VProductWhiteList.vue?vue&type=style&index=0&id=c8178872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8178872",
  null
  
)

export default component.exports